/**
 * Os eventos estruturados do login pelo IDP.
 *
 * Os nomes sao os do design (`idp_login.ok|no_vinculo|failed`) porque e por
 * eles que o alerta do `#alerts-idp` conta a virada da flag. Saem em JSON numa
 * linha so para o console do navegador: e o que o Sentry anexa como breadcrumb
 * e o que da para pedir a um usuario em suporte.
 *
 * **Nunca** recebe token, `code` ou `refresh_token` — o contrato proibe token
 * em log tanto quanto em URL.
 */

export type IdpLogEvent =
  | 'idp_login.ok'
  | 'idp_login.no_vinculo'
  | 'idp_login.failed'
  | 'idp_refresh.failed'
  | 'idp_logout.ok';

export type IdpLogData = Readonly<Record<string, string | number | boolean | undefined>>;

export function logIdp(event: IdpLogEvent, data: IdpLogData = {}): void {
  const linha = JSON.stringify({ event, ...data });
  if (event.endsWith('.failed') || event.endsWith('.no_vinculo')) {
    // eslint-disable-next-line no-console
    console.warn(linha);
    return;
  }
  // eslint-disable-next-line no-console
  console.info(linha);
}
